import { render, staticRenderFns } from "./OnlineCatalogue.vue?vue&type=template&id=b6919680"
import script from "./OnlineCatalogue.vue?vue&type=script&lang=js"
export * from "./OnlineCatalogue.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports